// DS: PO63
import React, { useContext, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import Button from '../Button';
import Flex from '@wix/da-ds/pkg/Flex';
import { ReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SocialLoginModuleLoader from '../SocialLogin/redux/ModuleLoader';
import SocialButtonApple from '../SocialLogin/SocialButtonApple';
import SocialButtonGoogle from '../SocialLogin/SocialButtonGoogle';
import SocialButtonFacebook from '../SocialLogin/SocialButtonFacebook';
import s from './SisuFunnelBanner.scss';
function isPinterest() {
    if (typeof document === 'undefined') {
        return false;
    }
    // Pinterest has a number of TLDs, so we gonna assume
    // any domain in the form "pinterest.[tld]" belongs to pinterest.
    return /^https?:\/\/(www\.)?pinterest\./.test(document.referrer);
}
var SisuFunnelBanner = function (_a) {
    var visible = _a.visible, restrictLoggedOut = _a.restrictLoggedOut;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var onJoinClick = useCallback(function () {
        restrictLoggedOut({
            restrictedActionName: ReferralType.SISU_FUNNEL_BANNER,
        });
    }, [restrictLoggedOut]);
    var hasSocialButtons = !isMobile;
    return (React.createElement(Flex, { className: classnames(s['root'], visible && s['root-visible']), alignItems: "center", justifyContent: "center", direction: isMobile ? 'column' : 'row' },
        React.createElement("span", { className: s['text'] }, isPinterest() ? t('sisuFunnel.text.pinterest') : t('sisuFunnel.text')),
        React.createElement(ReverseTheme, { className: s['buttons'] },
            React.createElement(Button, { href: Url.loginLink(), view: "b14-1", className: classnames(s['button'], s['login']), fullWidth: false, biData: {
                    evid: BiEventType.CLICK_LOGIN,
                    referral_info: ReferralType.SISU_FUNNEL_BANNER,
                } }, t('sisuFunnel.login')),
            React.createElement(Button, { onClick: onJoinClick, view: "b1-1", className: s['button'], fullWidth: false, biData: {
                    evid: BiEventType.CLICK_JOIN,
                    referral_info: ReferralType.SISU_FUNNEL_BANNER,
                } }, t('sisuFunnel.join')),
            hasSocialButtons && (React.createElement(SocialLoginModuleLoader, null,
                React.createElement("div", { className: s['social-separator'] }, t('sisuFunnel.separator')),
                React.createElement(SocialButtonGoogle, { className: s['social-button'], redirectToSisu: true, view: "icon", lazyload: true }),
                React.createElement(SocialButtonApple, { className: s['social-button'], view: "icon", redirectToSisu: true }, t('sisuFunnel.button.continue.apple')),
                React.createElement(SocialButtonFacebook, { className: s['social-button'], view: "icon", redirectToSisu: true }, t('sisuFunnel.button.continue.facebook')))))));
};
SisuFunnelBanner.displayName = 'SisuFunnelBanner';
export default SisuFunnelBanner;
//# sourceMappingURL=SisuFunnelBanner.js.map